import { render, staticRenderFns } from "./HotelReportTable.vue?vue&type=template&id=505e938d&scoped=true&"
import script from "./HotelReportTable.vue?vue&type=script&lang=js&"
export * from "./HotelReportTable.vue?vue&type=script&lang=js&"
import style0 from "./HotelReportTable.vue?vue&type=style&index=0&id=505e938d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e938d",
  null
  
)

export default component.exports